import React from 'react';
import { FormattedMessage } from 'react-intl/dist';

import { GIButton, Modal } from 'app-components';
import { useHistory } from 'react-router-dom';

import { ModalContextType } from '../../../contexts/modalContext';
import { configs } from '../../../constants/configs/configs';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    enrollmentEndDate: string;
}

export default function DisenrollIneligibleGroupModal({ closeModal, enrollmentEndDate }: IModalProps) {
    const history = useHistory();
    const { routes } = configs;

    function onClose(e) {
        e?.preventDefault();
        closeModal('disenrollIneligibleGroupModal');
        history.push(routes.INDPORTAL);
    }

    return (
        <Modal id="disenrollIneligibleGroupModal">
            <Modal.Header id="disenrollIneligibleGroupModalHeader" titleId="indportal.disenrollIneligibleGroup.involuntarydisenrollmentrequestsubmitted" onHide={onClose} />
            <Modal.Body id="disenrollIneligibleGroupModalBody">
                <p>
                    <FormattedMessage id="indportal.customGrouping.ineligibledisenrollgroup" values={{enrollmentEndDate}}/>
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="disenrollIneligibleGroupModalGoToDashboardButton" 
                    onClickHandler={onClose} 
                    variant="primary" 
                    labelId="button.go_to_dashboard" 
                />
            </Modal.Controls>
        </Modal>
    );
}
